import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactDialogComponent } from './components/contact-dialog/contact-dialog.component';
import { InputModule } from '../input/input.module';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    InputModule,
    CaptchaInputModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule
  ],
  declarations: [ContactDialogComponent],
  exports: [ContactDialogComponent]
})
export class ContactDialogModule { }
